// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"7f5966f0","232":"02bce413","237":"5aabca00","357":"0498c258","526":"a083b274","753":"c2ef3863","787":"512dd3f2","854":"3d28c354","872":"234addf2"}[chunkId] + ".chunk.js";
};